/**
 * Helper utility to format the status report CSV data with dynamic activity columns.
 * Formats a list of taxpayers status records, appending a column for each activity description.
 *
 * @param {Array} taxpayerReportStatus - List of status records from the API.
 * @param {Array} baseHeaders - The standard headers for the report.
 * @returns {Object} { headers, data } formatted for CSVLink.
 */
export const formatStatusReportCsv = (taxpayerReportStatus = [], baseHeaders = []) => {
  if (!Array.isArray(taxpayerReportStatus) || taxpayerReportStatus.length === 0) {
    return { headers: baseHeaders, data: [] };
  }

  // Find the maximum number of activities in any single taxpayer record
  let maxActivities = 0;
  taxpayerReportStatus.forEach((row) => {
    if (row && row.activities && Array.isArray(row.activities)) {
      if (row.activities.length > maxActivities) {
        maxActivities = row.activities.length;
      }
    }
  });

  // Construct dynamic headers adding "Actividad 1", "Actividad 2", etc.
  const headers = [...baseHeaders];
  for (let i = 0; i < maxActivities; i++) {
    headers.push({ label: `Actividad ${i + 1}`, key: `activity_${i}` });
  }

  // Map rows, adding a specific key for each activity's description
  const data = taxpayerReportStatus.map((row) => {
    const formattedRow = { ...row };
    if (row && row.activities && Array.isArray(row.activities)) {
      row.activities.forEach((activity, idx) => {
        formattedRow[`activity_${idx}`] = activity.description || '';
      });
    }
    return formattedRow;
  });

  return { headers, data };
};
